import { atom, selector } from 'recoil';
import { recoilPersist } from 'recoil-persist'
import { v4 as uuidv4 } from 'uuid';

const { persistAtom } = recoilPersist()

export const defaultTriggerItem = {
    name: 'TRIGGER',
    action_name: 'TRIGGER',
    id: uuidv4(),
    type: 'standard',
    hidden: false,
    libraryName: 'TRIGGER-STATIC',
    libraryLabel: 'TRIGGERSTATIC',
    library_label: 'TRIGGERSTATIC',
    actionName: 'TRIGGER',
    isDebugging: false,
    library_name: 'TRIGGER-STATIC',
    fields: {}
}

export const defaultItems = [
    {
        name: 'START',
        action_name: 'START',
        id: uuidv4(),
        type: 'standard',
        hidden: false,
        libraryName: 'START',
        actionName: 'START'
    },
    {
        name: 'STOP',
        action_name: 'STOP',
        id: uuidv4(),
        item_id: uuidv4(),
        type: 'standard',
        hidden: false,
        libraryName: 'STOP',
        actionName: 'STOP',
        isDebugging: false,
        libraryLabel: 'STOP',
        library_label: 'STOP',
        library_name: 'STOP',
        fields: {}
    }
]

export const defaultItemsForAction = [
    {
        name: 'START',
        action_name: 'START',
        id: uuidv4(),
        type: 'standard',
        hidden: false,
        libraryName: 'START',
        actionName: 'START'
    },
    {
        name: 'STOP',
        action_name: 'STOP',
        id: uuidv4(),
        type: 'standard',
        hidden: false,
        libraryName: 'STOP',
        actionName: 'STOP',
        isDebugging: false,
        libraryLabel: 'STOP',
        library_label: 'STOP',
        library_name: 'STOP',
        fields: {}
    }
]

export const activeAutom = atom({
    key: 'activeAutom',
    default: {
        name: '',
        mate_id: null,
        history: [],
        activeItem: [],
        items: defaultItems
    }
})

export const activeTab = atom({
    key: 'activeTab',
    default: 0,
    effects_UNSTABLE: [persistAtom]
})

export const activeUser = atom({
    key: 'activeUser',
    default: '',
    effects_UNSTABLE: [persistAtom],
})

export const unreadNotificationCount = atom({
    key: 'unreadNotificationCount',
    default: 0
})

export const oauthState = atom({
    key: 'oauthState',
    default: false
})


export const activeSideBarMenu = atom({
    key: 'activeSideBarMenu',
    default: {
        parent: 0,
        child: 0,
        thirdChild: 0
    }
})

export const queueLog = atom({
    key: 'queueLog',
    default: false
})

export const debugList = atom({
    key: 'debugList',
    default: []
})

export const testAppLog = atom({
    key: 'testAppLog',
    default: {}
})

export const automList = atom({
    key: 'automList',
    default: []
})

export const alertState = atom({
    key: 'alertState',
    default: {
        show: false,
        message: '',
        severity: 'info'
    }
})

export const fieldPreviewData = atom({
    key: 'fieldPreviewData',
    default: {
        triggerData: {
            data: {
                field_path: {},
                ff_name_path: {}
            },
            inputs: {},
            inputConfigurations: [],
            error: ''
        }
    }
});

export const actionFieldPreviewData = atom({
    key: 'actionFieldPreviewData',
    default: {
        actionsData: []
    }
});

export const triggerSelection = atom({
    key: 'triggerSelection',
    default: []
});

export const triggerConf = atom({
    key: 'triggerConf',
    default: {
        app: {},
        trigger: {},
        connector: {},
        setup: {
            fields: {},
            conditions: [],
            inputs: {}
        }
    }
});

export const selectedField = atom({
    key: 'selectedField',
    default: {
        key: '',
        name: '',
        type: '',
        path: []
    }
});

export const lastFocusField = atom({
    key: 'lastFocusField',
    default: {
        inputName: '',
        type: ''
    }
});

export const inputRefresh = atom({
    key: 'inputRefresh',
    default: new Date()
});

export const licensePermission = atom({
    key: 'licensePermission',
    default: undefined
});

export const rolePermission = atom({
    key: 'rolePermission',
    default: undefined
});

export const personalizationState = atom({
    key: 'personalizationState',
    default: undefined
});

export const inProgressListState = selector({
    key: 'inProgressListState',
    get: ({ get }) => {
        return get(automList).filter(item => item.operation_status === 'IN-PROGRESS')
    }
})

export const pendingListState = selector({
    key: 'pendingListState',
    get: ({ get }) => {
        return get(automList).filter(item => item.operation_status === 'PENDING')
    }
})

export const doneListState = selector({
    key: 'doneListState',
    get: ({ get }) => {
        return get(automList).filter(item => item.operation_status !== 'IN-PROGRESS' && item.operation_status !== 'PENDING')
    }
})

export const showObjectExplorerIcon = atom({
    key: 'showObjectExplorerIcon',
    default: false
})

export const schedulerNexRunTimes = atom({
    key: 'schedulerNextRunTimes',
    default: []
})